/**
 *
 * startCheckout
 * Create a subscription payment and resolve with the URL of its checkout
 * page. Rejects when the API fails or does not return a checkout link.
 *
 */

import { request2 } from 'utils/request';

async function startCheckout({ user, language, recurring }) {
  const body = {
    language,
    recurring,
    href: window.location.href,
  };
  const response = await request2({
    method: 'POST',
    url: '/user/subscribe',
    body,
    user,
    // A retry after a lost response would create a second, orphaned payment
    retry: false,
  });
  // eslint-disable-next-line no-underscore-dangle
  const href = response?._links?.checkout?.href;
  if (!href) {
    throw new Error('Subscribe response has no checkout link');
  }
  return href;
}

export default startCheckout;
